import { Modal } from 'antd';
import { messages } from 'src/constants/messages';
/**
 * Xoá item theo dạng custom api không dùng chung
 *
 * @param {*} error
 * @param {*} actionMethod
 * @param {*} params
 * @returns
 */
function ModalDeleteConfirmCutomAPI(error, actionMethod, params) {
  Modal.confirm({
    title: messages.MODAL_DELETE_TITLE,
    content: messages.MODAL_DELETE_CONTENT,
    onOk(e) {
      e();
      return new Promise((resolve, reject) => {
        actionMethod(params);
        if(!error) e();
        return error ? reject : resolve;
      }).catch(() => console.log('Có lỗi xảy ra!'));
    },
    okText: messages.MODAL_CONFIRM_OK,
    onCancel() {},
    cancelText: messages.MODAL_CONFIRM_CANCEL
  });
}

export default ModalDeleteConfirmCutomAPI;

